export default (settings: any) => settings['columns'] * (1 / 60) * 10
